export const CREATE_NEW_CHAT_CONVERSATION_SUCCESS = 'CREATE_NEW_CHAT_CONVERSATION_SUCCESS';

export const createNewChatConversationSuccess = ({ conversation }) => ({
    type: CREATE_NEW_CHAT_CONVERSATION_SUCCESS,
    payload: {
        conversation,
    }
});
